<form class="create-voyage-form" [formGroup]="fg">
  <div class="create-voyage-form__item">
    <div class="create-voyage-form__item-title">
      {{ "LABELS.STATUS" | translate }}
    </div>
    <div class="create-voyage-form__item-inputs">
      <div class="col-12 col-lg-3">
        <app-control-wrapper [control]="fg.get('status')" [isShowHelper]="false">
          <label for="status" control-label>
            {{ "LABELS.STATUS" | translate }}
          </label>
          <ng-select
            id="status"
            class="custom"
            control-wrapper
            bindLabel="label"
            bindValue="value"
            [formControl]="fg.get('status')"
            [items]="VOYAGE_STATUSES"
            [placeholder]="'LABELS.DRAFT' | translate"
            [clearable]="true"
          ></ng-select>
        </app-control-wrapper>
      </div>
    </div>
  </div>
  <div class="create-voyage-form__item">
    <div class="create-voyage-form__item-title">
      {{ "LABELS.ROUTE" | translate }}
    </div>
    <div class="create-voyage-form__item-inputs">
      <div class="col-12 col-lg-12">
        <auto-select
          id="route"
          [label]="'LABELS.ROUTE'"
          [bindLabel]="['displayName']"
          [change]="searchRoute"
          [errors]="errors"
          [fc]="fg.get('route')"
          [placeholder]="'FORM_PLACEHOLDER.SELECT' | translate"
          [clearable]="true"
        ></auto-select>
      </div>
    </div>
  </div>
  <div class="create-voyage-form__item">
    <div class="create-voyage-form__item-title">
      {{ "FORM_LABEL.VOYAGE_DETAILS" | translate }}
    </div>
    <div class="create-voyage-form__item-inputs">
      <div class="col-12 col-lg-6">
        <app-control-wrapper [control]="fg.get('voyageNumber')" [errors]="errors">
          <label for="voyageNumber" control-label>
            {{ "LABELS.VOYAGE_NUMBER" | translate }}
          </label>
          <div class="d-flex" control-wrapper>
            <input
              control-wrapper
              id="voyageNumber"
              class="form-control"
              formControlName="voyageNumber"
              type="text"
              maxlength="5"
              [placeholder]="'FORM_PLACEHOLDER.SELECT' | translate"
            />
          </div>
        </app-control-wrapper>
      </div>
      <div class="col-12 col-lg-6">
        <app-control-wrapper [control]="fg.get('vesselName')" [errors]="errors">
          <label for="vesselName" control-label>
            {{ "LABELS.VESSEL_NAME" | translate }}
          </label>
          <div class="d-flex" control-wrapper>
            <input
              control-wrapper
              id="vesselName"
              class="form-control"
              formControlName="vesselName"
              type="text"
              [placeholder]="'FORM_PLACEHOLDER.SELECT' | translate"
            />
          </div>
        </app-control-wrapper>
      </div>
    </div>
  </div>
  <div class="create-voyage-form__item">
    <div class="create-voyage-form__item-title">
      {{ "LABELS.DATES" | translate }}
    </div>
    <div class="create-voyage-form__item-inputs">
      <div class="col-12 col-lg-4">
        <date-picker
          id="etd"
          name="estimatedDepartureTime"
          [minDate]="todayDate"
          [label]="'LABELS.ETD'"
          [fc]="fg.get('estimatedDepartureTime')"
          placeholder="FORM_PLACEHOLDER.SELECT"
        ></date-picker>
      </div>
      <div class="col-12 col-lg-4">
        <date-picker
          id="eta"
          [name]="'estimatedArrivalTime'"
          [label]="'LABELS.ETA'"
          [minDate]="etaMinDate"
          [fc]="fg.get('estimatedArrivalTime')"
          [placeholder]="'FORM_PLACEHOLDER.SELECT'"
        ></date-picker>
      </div>
      <div class="col-12 col-lg-4">
        <date-picker
          id="cutoff"
          [minDate]="todayDate"
          [name]="'warehouseCutoff'"
          [label]="'LABELS.PREPARATION_CUTOFF'"
          [maxDate]="fg.get('estimatedDepartureTime').value"
          [fc]="fg.get('warehouseCutoff')"
          [placeholder]="'FORM_PLACEHOLDER.SELECT'"
        ></date-picker>
      </div>
    </div>
  </div>
  <div class="create-voyage-form__item">
    <div class="create-voyage-form__item-title">
      {{ "FORM_LABEL.PRICES" | translate }}
    </div>
    <div class="create-voyage-form__item-inputs">
      <div class="col-12 col-lg-4">
        <app-control-wrapper [control]="fg.get('combinedPricelistId')" [errors]="errors">
          <label for="combinedPricelist" control-label>
            {{ "DOCUMENT_TYPE.PRICE_LIST" | translate }}
          </label>
          <ng-select
            id="combinedPricelist"
            class="custom"
            control-wrapper
            [formControl]="fg.get('combinedPricelistId')"
            [items]="combinedPricelists"
            [placeholder]="'FORM_PLACEHOLDER.SELECT_AGENT' | translate"
            [clearable]="true"
          >
            <ng-template ng-label-tmp let-item="item">
              <label class="ng-value-label">{{ item.destinationAgent.name + " " + item.id }}</label>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <label class="ng-value-label">
                <div class="combined-subcost-item">
                  <div class="combined-subcost-icon origin">A</div>
                  {{ item.originAgent.name + " " + item.id }}
                </div>

                <div class="combined-subcost-item">
                  <div class="combined-subcost-icon freight"></div>
                  {{ item.freightAgent.name }}
                </div>

                <div class="combined-subcost-item">
                  <div class="combined-subcost-icon destination">B</div>
                  {{ item.destinationAgent.name }}
                </div>
              </label>
            </ng-template>
          </ng-select>
        </app-control-wrapper>
      </div>

      <div class="col-12 col-lg-8" *ngIf="hasPriceListError">
        <div class="price-list-error-container mt-4">
          <img src="assets/icons/warning-red.svg" />
          <div class="price-list-error-container-description">
            <div class="fail-message" *ngIf="combinedPricelistsNoMargin">
              {{
                "LABELS.MISSING_COMBINED_PRICELIST_MARGINS"
                  | translate
                    : {
                        date: fg.get("estimatedDepartureTime").value | customDateByUtc
                      }
              }}
            </div>

            <div class="fail-message" *ngIf="isShowPriceListETDError">
              {{
                "LABELS.MISSING_PRICELIST_FOR_ETD_SHORT"
                  | translate
                    : {
                        date: fg.get("estimatedDepartureTime").value | customDateByUtc
                      }
              }}
            </div>

            <div
              class="fail-message"
              *ngIf="
                combinedPricelistsHasColoadingOriginError ||
                combinedPricelistsHasColoadingDestinationError ||
                combinedPricelistsHasFullContainerDestinationError
              "
            >
              {{
                "LABELS.MISSING_PRICELIST_FOR_ETD_FULL"
                  | translate
                    : {
                        agentName: agentName,
                        container: containerError,
                        portName: portName,
                        routeName: routeName
                      }
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
